var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40003 0.40039C1.84185 0.40039 2.20003 0.758562 2.20003 1.20039L2.20003 10.8004C2.20003 11.2422 1.84185 11.6004 1.40002 11.6004C0.958196 11.6004 0.600025 11.2422 0.600025 10.8004L0.600025 1.20039C0.600025 0.758562 0.958198 0.40039 1.40003 0.40039ZM7.56571 3.0347C7.87813 3.34712 7.87813 3.85366 7.56571 4.16608L6.5314 5.20039L12.6 5.20039C13.0419 5.20039 13.4 5.55856 13.4 6.00039C13.4 6.44222 13.0419 6.80039 12.6 6.80039L6.5314 6.80039L7.56571 7.83471C7.87813 8.14712 7.87813 8.65366 7.56571 8.96608C7.25329 9.2785 6.74676 9.2785 6.43434 8.96608L4.03434 6.56608C3.88431 6.41605 3.80002 6.21256 3.80002 6.00039C3.80002 5.78822 3.88431 5.58473 4.03434 5.4347L6.43434 3.0347C6.74676 2.72229 7.25329 2.72229 7.56571 3.0347Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.3a3159062b028de8109cb1f03961dfc4.svg";
export { ForwardRef as ReactComponent };